import { poUploadJobIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const cancelPoUpload = {
  name: "cancelPoUpload" as const,
  input: z.object({ jobId: poUploadJobIdFormat.schema }),
  output: z.object({}),
};
